/**
 * EmptyObservabilityService is used as an override in the embed-report.module
 * (which includes headless-viewer.component and the iframe report viewer components)
 * The headless viewer cannot pull in the observability service w/o issues in pdf export.
 * This empty service allows the headless viewer to pull in it's own observability service
 * with the necassary stubbed functions that are used in the flamingo client service. If
 * the iframe application requires the window.performance API in the future this strategy
 * will need to be replaced.
 */
export class EmptyObservabilityService {
  public mark() {}

  public measure() {}
}
